<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <router-link to="/invoice-apply/approve/pre-received/table?issued_type=2"
                   v-if="!$route.meta.is_pre_received"
                   style="float: right;">
        预收款发票
      </router-link>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="开票ID"
                        key="id"
                        prop="id">
            <el-input v-model="search.id"
                      clearable
                      placeholder="请输入开票ID">
            </el-input>
          </el-form-item>
          <el-form-item label="客户名称"
                        prop="customerid">
            <remote-select style="width: 100%;"
                           v-model="search.customerid"
                           filterable
                           remote
                           clearable
                           id-key="number"
                           keyword-key="name"
                           :label="customerLabel"
                           value-key="id"
                           placeholder="请输入客户名称/编号搜索"
                           :query-request="customerRemoteMethod"
                           @change="search.projectid=null"
                           :find-request="getCustomerInfoRemote">
            </remote-select>
          </el-form-item>

          <el-form-item label="BO审批"
                        prop="bu_approver">
            <remote-select style="width: 100%;"
                           v-model="search.bu_approver"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入管理员名称搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="申请描述"
                        prop="desc">
            <el-input style="width: 100%;"
                      v-model="search.desc"
                      clearable
                      placeholder="请输入申请描述关键字搜索">
            </el-input>
          </el-form-item>

          <el-form-item label="开票状态"
                        prop="status">
            <el-select v-model="search.status"
                       clearable
                       multiple
                       class="width-max"
                       placeholder="请选择">
              <el-option
                v-for="item in options.status"
                :key="item.value"
                :label="item.label"
                :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开票日期"
                        prop="invoice_time">
            <el-date-picker v-model="search.invoice_time"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="开票金额">
            <el-col :span="11">
              <el-form-item prop="total_amount_min">
                <el-input v-model="search.total_amount_min"
                          clearable
                          placeholder="请输入含税金额起始值"/>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
            </el-col>
            <el-col :span="11"
                    :offset="1">
              <el-form-item prop="total_amount_max">
                <el-input v-model="search.total_amount_max"
                          clearable
                          placeholder="请输入含税金额结束值"/>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="项目编号"
                        prop="project_id">
            <el-input style="width: 100%;"
                      v-model="search.project_number"
                      clearable
                      placeholder="请输入项目编号搜索">
            </el-input>
          </el-form-item>
          <el-form-item label="开票类别"
                        prop="issued_type">
            <el-select v-model="search.issued_type"
                       clearable
                       :disabled="$route.meta.is_pre_received"
                       class="width-max"
                       placeholder="请选择">
              <el-option
                v-for="item in options.issued_type"
                :key="item.value"
                :label="item.label"
                :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发起人"
                        prop="initiator">
            <remote-select style="width: 100%;"
                           v-model="search.initiator"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入发起人名称搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="开票主体"
                        prop="subject">
            <remote-select class="width-max"
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="仅支持搜索启用中的开票主体公司,可输入名称进行搜索"
                           v-model="search.subject"
                           :query-request="(_)=>getFinCenterOurCompaniesTable(Object.assign(_, {is_disabled: 0}))"
                           :find-request="getFinCenterOurCompaniesDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="回款状态"
                        prop="received_payment_status">
            <el-select v-model="search.received_payment_status"
                       clearable
                       class="width-max"
                       placeholder="请选择">
              <el-option
                v-for="item in options.received_payment_status"
                :key="item.value"
                :label="item.label"
                :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回款日期"
                        prop="collection_date">
            <el-date-picker v-model="search.collection_date"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>

          <!-- 仅预收款开票页面展示抵扣状态搜索项 -->
          <el-form-item label="抵扣状态"
                        v-if="$route.meta.is_pre_received"
                        prop="deduction_status">
            <el-select v-model="search.deduction_status"
                       clearable
                       @change="changeDeductionStatus"
                       class="width-max"
                       placeholder="请选择">
              <el-option
                v-for="item in options.deduction_status"
                :key="item.value"
                :label="item.label"
                :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>

        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15"
           style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
        <div>
          <el-button type="primary"
                     size="small"
                     v-if="this.$route.query.old_export"
                     @click="onExportSearchFix()">搜索结果导出
          </el-button>
          <el-button type="primary"
                     v-if="!$route.meta.is_pre_received"
                     icon="sj-icon-export"
                     size="small"
                     @click="exportReceiptList()">搜索结果导出
          </el-button>
          <el-button type="primary"
                     v-if="$route.meta.is_pre_received"
                     icon="sj-icon-export"
                     size="small"
                     @click="exportPreReceiptList()">搜索结果导出
          </el-button>
          <el-button type="primary"
                     size="small"
                     @click="openSumTaxedAmountDialog">按搜索结果汇总
          </el-button>

          <template v-if="!$route.meta.is_pre_received">
            <el-button type="primary"
                       v-if="this.$route.query.old_export"
                       size="small"
                       @click="exportCollection">导出开票回款明细(前端导出)
            </el-button>
            <el-button type="primary"
                       size="small"
                       v-if="this.$route.query.old_export"
                       @click="exportUnCollection">导出开票未回款明细(前端导出)
            </el-button>
            <el-button type="primary"
                       icon="sj-icon-export"
                       size="small"
                       @click="exportReceiptCollection">导出开票回款明细
            </el-button>
            <el-button type="primary"
                       icon="sj-icon-export"
                       size="small"
                       @click="exportUnReceiptCollection">导出开票未回款明细
            </el-button>
          </template>

          <el-button type="primary"
                    @click="batchDownloadPdf"
                    :disabled="mulSelection.length < 1"
                    size="small">批量生成PDF
          </el-button>
        </div>
        <div>
          <router-link to="/invoice-apply/split/table">
            <el-button type="primary"
                       size="small">拆分发票列表
            </el-button>
          </router-link>
        </div>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                @selection-change="(val) => this.mulSelection = val.map(item => item.id)"
                @sort-change="sortChange">
        <el-table-column type="selection"
                  width="40">
        </el-table-column>
        <el-table-column prop="id"
                         label="ID"
                         sortable="custom"
                         min-width="90"></el-table-column>
        <el-table-column prop="desc"
                         label="申请描述"
                         min-width="120">
          <template slot-scope="scope">
            <div @click="openDetail(scope.row.id)"
                 style="color: #409EFF;cursor: pointer;">
              {{ scope.row.desc }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户编号"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.customer_name }}/{{ scope.row.customer_number }}
          </template>
        </el-table-column>
        <el-table-column prop="receipt_info_company_name"
                         label="公司名称"
                         width="190">
        </el-table-column>

        <!--   预收款发票的虚拟项目编号信息     -->
        <el-table-column prop="virtual_project"
                         :key="`virtual_project`"
                         label="项目编号"
                         v-if="$route.meta.is_pre_received"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.virtual_project.name }}/{{ scope.row.virtual_project.number }}
          </template>
        </el-table-column>

        <el-table-column prop="issued_type"
                         :key="`issued_type`"
                         label="开票类别"
                         v-if="!$route.meta.is_pre_received"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.issued_type"
                  v-if="scope.row.issued_type * 1 === item.value * 1">
              {{ item.label }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="status"
                         :key="`status`"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="scope.row.status === item.value"
                  :style="{color: item.color}">{{ item.label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deduction_status"
                         :key="`deduction_status`"
                         v-if="$route.meta.is_pre_received"
                         label="抵扣状态"
                         min-width="120">
          <template slot-scope="scope">
              <span v-for="item in options.deduction_status"
                    v-if="scope.row.deduction_status * 1 === item.value * 1">
                {{ scope.row.status * 1 === 7 ? item.label : '-' }}
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="untaxed_amount"
                         :key="`untaxed_amount`"
                         label="未税开票金额"
                         v-if="!$route.meta.is_pre_received"
                         min-width="120">
          <template slot-scope="scope">
            <span :style="amountStyle(scope.row)">
              ￥{{ scope.row.untaxed_amount | seperateThousandsToFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="total"
                         :key="`total`"
                         label="含税开票金额"
                         min-width="120">
          <template slot-scope="scope">
            <span :style="amountStyle(scope.row)">
              ￥{{ scope.row.total | seperateThousandsToFixed(2) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="received_payment_status"
                         label="回款状态"
                         width="190">
          <template slot-scope="scope">
            {{[6,7,8].includes(scope.row.status) ? (options.received_payment_status.find(item => item.value === scope.row.received_payment_status) || {}).label : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="collection_remains_total"
                         label="待回款金额"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.collection_remains_total }}
          </template>
        </el-table-column>
        <el-table-column prop="collection_total"
                         label="已回款金额"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.collection_total }}
          </template>
        </el-table-column>

        <template v-if="$route.meta.is_pre_received">
          <el-table-column prop="available_deduct_amount"
                           :key="`available_deduct_amount`"
                           label="可用抵扣金额"
                           min-width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status * 1 === 7">
                ￥{{ scope.row.available_deduct_amount | seperateThousandsToFixed(2) }}
              </div>
              <div v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="deducted_amount"
                           :key="`deducted_amount`"
                           label="已抵扣金额"
                           min-width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status * 1 === 7">
                ￥{{ scope.row.deducted_amount | seperateThousandsToFixed(2) }}
              </div>
              <div v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column>
        </template>

        <el-table-column prop="initiator_name"
                         :key="`initiator_name`"
                         label="发起人"
                         min-width="120"></el-table-column>
        <el-table-column prop="bu_name"
                         :key="`bu_name`"
                         label="BO审批"
                         min-width="120"></el-table-column>
        <el-table-column label="创建时间 更新时间"
                         sortable="custom"
                         prop="updated_at"
                         :key="`updated_at`"
                         min-width="180">
          <template slot-scope="scope">
            {{ scope.row.created_at }} <br/>
            {{ scope.row.updated_at }}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         :key="`operation`"
                         width="230">
          <template slot-scope="scope">
            <approve-operation-buttons :scope="scope"
                                       @refresh="onRefresh"
                                       @approveInvoice="approve"
                                       @completeInvoice="complete"
                                       @voidInvoice="voidReceipt"></approve-operation-buttons>

            <template v-if="isShowDeductBtn(scope.row)">
              <br>
              <el-button type="warning"
                         size="mini"
                         v-if="isShowApproveBtn(scope.row)"
                         @click="approveDeduct(scope.row)">抵扣-财务审批
              </el-button>
            </template>
            <template v-if="isShowRetryBtn(scope.row)">
              <el-button type="primary"
                         size="mini"
                         @click="retrySyncKingDee(scope.row)">重试同步
              </el-button>
            </template>

          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <sum-taxed-amount-dialog :visible="sumVisible"
                             :amountStatistics="amountStatistics"
                             :title="title"
                             :isPreReceivedPage="$route.meta.is_pre_received"
                             @closeDialog="sumVisible=false"></sum-taxed-amount-dialog>

    <el-dialog title="预收款发票导出错误"
               :visible="exportErrVisible"
               width="50%">
      <span>搜索结果中无已签收的预收款发票，或者所有已签收的预收款发票中不存在抵扣成功的条目数据</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="closeExportErrDialog">确认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import downloadJS from '@/vendor/download'
import ApproveOperationButtons from '@/views/invoice-apply/components/ApproveOperationButtons'
import SumTaxedAmountDialog from '@/views/invoice-apply/components/SumTaxedAmountDialog'
import dateTimePicker from '@core/mixins/dateTimePicker'
import selectRemote from '@core/mixins/selectRemote'
import table, { removeEmptyParams } from '@core/mixins/table'
import { getToken } from '@utils/auth'
import { searchRules } from '../invoice-apply.rules.js'
import RemoteSelect from '@core/components/RemoteSelect'

export default {
  mixins: [table, dateTimePicker, selectRemote],
  components: {
    RemoteSelect,
    ApproveOperationButtons,
    SumTaxedAmountDialog,
  },
  data () {
    return {
      searchRules,
      search: {
        id: null,
        status: [],
        customerid: null,
        bu_approver: null,
        initiator: null,
        created_at: [],
        invoice_time: [],
        sort_by_updated_at: null,
        sort_by_id: null,
        total_amount_min: null,
        total_amount_max: null,
        project_number: null,
        issued_type: null,
        subject: null,
        received_payment_status: null,
        is_from_finance: 1,
        collection_date: []
      },
      searchFieldType: {
        customerid: String,
        bu_approver: Number,
        initiator: Number,
        total_amount_min: Number,
        total_amount_max: Number,
        project_number: String,
      },
      selectLoading: false,
      customerItems: [],
      adminuserItems: [],
      exportHeader: [],
      exportErrVisible: false,
      dialogType: null,
      title: null,
      sumVisible: false,
      amountStatistics: [],
      titlePrefix: '开票申请 - ',
      paymentCompanys: {},
      costTypes: {},
      mulSelection: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
      user: state => state.login.user,
      export_headers: state => state.invoiceApply.receipt_export_headers,
      pre_export_headers: state => state.invoiceApply.pre_receipt_export_headers,
      uncollection_export_header: state => state.invoiceApply.uncollection_export_header,
      collection_export_header: state => state.invoiceApply.collection_export_header,
    }),
  },
  created () {},
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getFinCenterConfigs()
    })
  },
  beforeRouteLeave (to, from, next) {
    // 离开时，清除当前页面设置的查询参数，避免在其他的提现页面保留这些查询参数
    if (this.$route.meta.is_pre_received) {
      this.search.issued_type = null
    }
    Object.assign(this.$data, this.$options.data.call(this))
    next()
  },
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map(['getFinCenterOurCompaniesTable', 'getFinCenterOurCompaniesDetail']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getInvoiceApproveTable', params)
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.paymentCompanys = this.expandData(data.payment_apply_our_company_source)
        this.costTypes = this.expandData(data.receipt_detail_cost_type)
      })
    },
    expandData (data) {
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    sortChange (column, prop, order) {
      this.search.sort_by_id = this.search.sort_by_updated_at = null
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop === 'id') {
        this.search.sort_by_id = sortBy
      } else if (column.prop === 'updated_at') {
        this.search.sort_by_updated_at = sortBy
      }
      this.onSearch()
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
      if (this.$route.meta.is_pre_received) {
        this.search.issued_type = '2'
      }
    },
    getExportData (params) {
      params.is_from_finance = true
      if (this.$route.meta.is_pre_received) {
        // 预收款发票数据导出,未指定状态时,锁定导出已签收状态的发票
        if (!params.status) {
          params.status = [7]
        }
        params.has_passed_deduction = 1
        return request.page('getExportPreReceivedApproveTable', params)
      }
      return request.page('getExportApproveTable', params)
    },
    onExportSearchFix () {
      let params = filter.copyJson(removeEmptyParams(this.search))
      params.per_page = 1
      this.getExportData(params).then(({data}) => {
        if (data.data.length < 1 && this.$route.meta.is_pre_received) {
          this.exportErrVisible = true
        } else {
          this.onExportSearch()
        }
      })
    },
    onExportSearch () {
      this.exportHeader = this.$route.meta.is_pre_received ? this.pre_export_headers : this.export_headers
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },
    handleExportData (data) {
      data.forEach((row) => {
        row.tax_rate = row.tax_rate + '%'
        row.buyer_company_name = row.receipt_info_json.company_name || '' // 购买方公司名称
        row.buyer_tax_number = row.receipt_info_json.tax_number || '' // 购买方纳税人识别号
        row.quantity = row.quantity > 0 ? row.quantity : '' // 数量大于0时显示数字
        this.options.tax_type.forEach((status) => {
          if (status.value * 1 === row.invoice_tax_type * 1) {
            row.invoice_tax_type_cn = status.label
          }
        })
        this.options.status.forEach((status) => {
          if (status.value * 1 === row.status * 1) {
            row.status = status.label
          }
        })
        row.cost_type = this.costTypes[row.cost_type]
        this.options.issued_type.forEach((issuedType) => {
          if (issuedType.value * 1 === row.issued_type * 1) {
            row.issued_type = issuedType.label
          }
        })
        if (row.subject) {
          row.subject = this.paymentCompanys[row.subject]
        }
        this.options.type.forEach(type => {
          if (type.value * 1 === row.type * 1) {
            row.type = type.label
          }
        })
        if (row.deduction_status) {
          this.options.deduction_status.forEach((deductType) => {
            if (deductType.value * 1 === row.deduction_status * 1) {
              row.deduction_status = deductType.label
            }
          })
        }
      })
      return data
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportInvoiceApplyData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    customerRemoteMethod (query) {
      return request.common('getCustomerTable', {keyword: query.name, type: [10, 70]})
    },
    getCustomerInfoRemote () {
      return request.common('getCustomerDetail', {id: this.search.customerid})
    },
    customerLabel (item) {
      return item.name + '/' + item.number
    },
    changeDeductionStatus () {
      if (this.search.deduction_status * 1 === 1) {
        if (this.search.status.length === 0) {
          this.search.status = ['7']
        }
      }
    },
    isShowDeductBtn (item) {
      return item.issued_type * 1 === 2 && item.status * 1 === 7
    },
    isShowRetryBtn (item) {
      return [15, 16, 17].includes(item.status * 1) && item.sync_kingdee_fail > 0
    },
    isShowApproveBtn (item) {
      // 超管和指定的财务审批人,财务管理员可以看到按钮
      return (item.deduct_detail_status_list.includes(2) || item.deduct_detail_status_list.includes('2')) &&
        (this.user.id * 1 === item.finance_approver * 1 || [1, 5].includes(this.user.usertype * 1))
    },
    approveDeduct (id) {
      window.location.href = `/invoice-apply/review/deduct-finance-approve/${id.id}`
    },
    retrySyncKingDee (item) {
      if (item.sync_kingdee_fail < 1) {
        this.$confirm('此数据尚未自动同步金蝶,若手动进行同步,有概率导致数据异常,是否继续手动同步？', '警告', {
          type: 'warning',
          confirmButtonText: '放弃本次操作', // 本意不希望用户手动同步,因此在确认高亮按钮位置放置放弃功能
          cancelButtonText: '继续手动同步',
          closeOnPressEscape: false, // 按下 ESC 键关闭弹窗
          closeOnClickModal: false, // 点击遮罩关闭弹窗
          distinguishCancelAndClose: true, // 区分取消与关闭
        }).then(() => {
          this.$message.info('已放弃手动同步')
        }, (action) => {
          // 手动点击取消位置的按钮
          if (action === 'cancel') {
            this.doSyncKingDee(item)
          } else {
            this.$message.info('已放弃手动同步')
          }
        })
      } else {
        this.doSyncKingDee(item)
      }
    },
    doSyncKingDee (item) {
      request.common('retrySyncKingDeeApi', {id: item.id}).then(({data}) => {
        this.$message.success('同步成功')
        this.onRefresh()
      })
    },
    openDetail (id) {
      window.location.href = `/invoice-apply/finance/detail/${id}?type=detail&from=approve`
    },
    approve (id) {
      window.location.href = `/invoice-apply/review/finance-approve/${id.id}`
    },
    complete (id) {
      window.location.href = `/invoice-apply/review/complete/${id.id}`
    },
    voidReceipt (id) {
      window.location.href = `/invoice-apply/review/void/${id.id}`
    },
    closeExportErrDialog () {
      this.exportErrVisible = false
    },
    async openSumTaxedAmountDialog () {
      this.amountStatistics = []
      if (this.$route.meta.is_pre_received) {
        let params = removeEmptyParams(filter.copyJson(this.search))
        params.issued_type = '2'
        params.status = ['7']
        await request.common('getPrepareInvoiceAmountTotal', params).then((data) => {
          let totalLength = 0
          let totalAvailableAmount = 0
          let totalFreezeAmount = 0
          let totalDeductedAmount = 0
          for (const i in data.data) {
            if (data.data.hasOwnProperty(i)) {
              totalLength += data.data[i].length
              totalAvailableAmount += data.data[i].available_deduct_amount
              totalFreezeAmount += data.data[i].freeze_deduct_amount
              totalDeductedAmount += data.data[i].deducted_amount
              this.amountStatistics.push(data.data[i])
            }
          }
          if (totalLength) {
            this.amountStatistics.push({
              'deduction_status': -1, // -1 为 总计 列，需单独处理显示文字
              'length': totalLength,
              'available_deduct_amount': totalAvailableAmount,
              'freeze_deduct_amount': totalFreezeAmount,
              'deducted_amount': totalDeductedAmount,
            })
          }
          this.title = '预收款开票统计'
          this.sumVisible = true
        })
      } else {
        await request.common('getInvoiceAmountTotal', removeEmptyParams(this.search)).then((data) => {
          let totalLength = 0
          let totalTaxedAmount = 0
          let totalUntaxedAmount = 0
          for (const i in data.data) {
            if (data.data.hasOwnProperty(i)) {
              totalLength += data.data[i].length
              totalTaxedAmount += data.data[i].total
              totalUntaxedAmount += data.data[i].untaxed_amount
              this.amountStatistics.push(data.data[i])
            }
          }
          if (totalLength) {
            this.amountStatistics.push({
              'status': -1, // -1 为 总计 列，需单独处理显示文字
              'length': totalLength,
              'untaxed_amount': totalUntaxedAmount,
              'total': totalTaxedAmount,
            })
          }
          this.title = '开票统计'
          this.sumVisible = true
        })
      }
    },
    exportUnCollection () {
      let params = filter.copyJson(removeEmptyParams(this.search))
      request.common('receiptApplicationsUnCollection', params).then(({data}) => {
        if (data.data.length < 1) {
          this.$alert('搜索结果中无已开票或已签收的开票。', '导出开票未回款明细错误', {type: 'warning'}).then(() => {
          })
        } else {
          this.$export('开票未回款明细', {
            fileHeader: this.uncollection_export_header,
            total: this.pagination.total,
            request: (params) => request.page('receiptApplicationsUnCollection', params),
            requestParams: params,
          })
        }
      })
    },
    exportCollection () {
      let params = filter.copyJson(removeEmptyParams(this.search))
      request.common('receiptApplicationsCollection', params).then(({data}) => {
        if (data.data.length < 1) {
          this.$alert('搜索结果中无已开票或已签收的开票，或者搜索结果中不存在有关联回款记录的开票。', '导出开票回款明细错误', {type: 'warning'}).then(() => {
          })
        } else {
          this.$export('开票回款明细', {
            fileHeader: this.collection_export_header,
            total: this.pagination.total,
            request: (params) => request.page('receiptApplicationsCollection', params),
            requestParams: params,
            getResponseData: (data) => {
              data.data.forEach((row) => {
                row.cost_type = this.costTypes[row.cost_type]
              })
              return data
            }
          })
        }
      })
    },
    amountStyle (row) {
      return [11, 14, 17].includes(row.status * 1) ? 'color:red;' : ''
    },
    batchDownloadPdf () {
      request.common('batchDownloadInvoicePdfs', {id: this.mulSelection}).then((data) => {
        let filename = data.data
        let api = request.items.downloadPdfFileFromServer({filename: filename})
        downloadJS(api, false, false, {
          'SJ-Auth-Token': getToken()
        })
      })
    },
    getRemovedEmptySearch () {
      return removeEmptyParams(_.cloneDeep(this.search))
    },
    exportReceiptList () {
      const params = this.getRemovedEmptySearch()
      params.per_page = 1
      this.getExportData(params).then(({data}) => {
        if (data.data.length < 1) {
          this.$alert('当前查询条件下没有开票单数据，请调整搜索条件后再导出数据', '提示', {type: 'warning'})
          return
        }
        this.$confirm('确定按搜索条件导出开票列表数据？', '提示', {type: 'warning'}).then(() => {
          const params = this.getRemovedEmptySearch()
          params.is_from_finance = true
          request.common('exportReceiptListApi', params).then((res) => {
            this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: '/batch-jobs/finance-export-jobs'})
            })
          })
        })
      })
    },
    exportPreReceiptList () {
      const params = this.getRemovedEmptySearch()
      this.getExportData({...params, per_page: 1}).then(({data}) => {
        if (data.data.length < 1) {
          this.exportErrVisible = true
        } else {
          this.$confirm('确定按条件导出预收款开票列表数据？', '提示', {type: 'warning'}).then(() => {
            const params = this.getRemovedEmptySearch()
            params.is_from_finance = true
            request.common('exportPreReceiptListApi', params).then((res) => {
              this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
                this.$router.push({path: '/batch-jobs/finance-export-jobs'})
              })
            })
          })
        }
      })
    },
    exportReceiptCollection () {
      let params = removeEmptyParams(_.cloneDeep(this.search))
      request.common('receiptApplicationsCollection', {...params, per_page: 1}).then(({data}) => {
        if (data.data.length < 1) {
          this.$alert('搜索结果中无已开票或已签收的开票，或者搜索结果中不存在有关联回款记录的开票。', '导出开票回款明细错误', {type: 'warning'}).then(() => {
          })
        } else {
          this.$confirm('确定按搜索条件导出开票回款明细数据？', '提示', {type: 'warning'}).then(() => {
            request.common('exportReceiptCollectionApi', this.getRemovedEmptySearch()).then((res) => {
              this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
                this.$router.push({path: '/batch-jobs/finance-export-jobs'})
              })
            })
          })
        }
      })
    },
    exportUnReceiptCollection () {
      let params = removeEmptyParams(_.cloneDeep(this.search))
      request.common('receiptApplicationsUnCollection', {...params, per_page: 1}).then(({data}) => {
        if (data.data.length < 1) {
          this.$alert('搜索结果中无已开票或已签收的开票。', '导出开票未回款明细错误', {type: 'warning'})
        } else {
          this.$confirm('确定按搜索条件导出开票未回款明细数据？', '提示', {type: 'warning'}).then(() => {
            request.common('exportUnReceiptCollectionApi', this.getRemovedEmptySearch()).then((res) => {
              this.$confirm('任务创建成功, 是否前往批量任务页面？', '提示', {type: 'success'}).then(() => {
                this.$router.push({path: '/batch-jobs/finance-export-jobs'})
              })
            })
          })
        }
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/InvoiceApproveTable.vue